var passwordStrength = function () {
    $('[data-id="meter"]').entropizer({
        target: '[data-id="password"]',
        buckets: [
       	        { max: 60, strength: 'Password strength: Weak', color: '#b30432' },
				{ min: 60, max: 80, strength: 'Password strength: Good', color: '#ff8800' },
			    { min: 80, strength: 'Password strength: Strong', color: '#41dc5d' }
        ],
        update: function (data, ui) {
            ui.bar.css({
                'background-color': data.color,
                'width': data.percent + '%'
            });
            ui.text.html(data.strength);
        }
        
    });
};
